import { EventCarouselProps } from '../../../../types'

import { Header } from '../Header'
import { Slide } from './Slide'
import { SwiperReactFacade } from '../../'
import cls from 'classnames'
import { fourColSettings } from '../../settings'
import React, { FC } from 'react'

export type EventCarouselComponentProps = EventCarouselProps & {
    className?: string
}

export const EventCarouselComponent: FC<EventCarouselComponentProps> = ({ className = '', ...props }) => {
    const { eventItems, title } = props.displayText
    const items = eventItems.map(item => ({ ...item, id: item.eventId }))
    const options = fourColSettings(eventItems.length)
    const hideArrows = items.length <= 4

    const numberOfSlidesClass = cls({ 'event-carousel__single-slide': eventItems.length === 1 })

    return (
        <>
            <div className={`${numberOfSlidesClass} ${className}`}>
                <Header title={title} />
                <SwiperReactFacade options={options} hideArrows={hideArrows} className="event-carousel">
                    {items.map(eventItem => (
                        <Slide event={eventItem} key={eventItem.id} numberOfSlides={items.length} />
                    ))}
                </SwiperReactFacade>
            </div>
        </>
    )
}

export default EventCarouselComponent
